// Ported from _docs/design/shell.jsx::TopBar — same markup, TS types, no
// fileName for now since the wizard hosts that.
import { useLangStore, type Lang } from "../../stores/language";
import { Icon } from "../Icon";

export function TopBar({
  fileName,
  onTitleClick,
  showHome,
}: {
  fileName?: string;
  onTitleClick?: () => void;
  showHome?: boolean;
}) {
  const lang = useLangStore((s) => s.lang);
  const setLang = useLangStore((s) => s.setLang);
  return (
    <header className="topbar">
      <div className="brand-row" onClick={onTitleClick} style={{ cursor: "pointer" }}>
        <div className="brand-mark">
          <Icon name="leaf" size={18} color="#ecf5ef" />
        </div>
        <div>
          <div className="brand-name-dark">Ensovia · Lease Analysis</div>
          <div className="brand-sub-dark">Document analysis</div>
        </div>
      </div>

      {showHome && (
        <button
          className="btn btn-secondary btn-sm"
          onClick={onTitleClick}
          title="Back to the list of all analyses"
        >
          <Icon name="back" size={13} /> All analyses
        </button>
      )}

      {fileName && (
        <span className="project-chip">
          <Icon name="file" size={12} />
          <span
            style={{
              maxWidth: 360,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {fileName}
          </span>
        </span>
      )}

      <div className="header-actions">
        <span className="lang-switch-label">Analysis text</span>
        <div
          className="lang-switch"
          role="group"
          aria-label="Language of the analysis text"
          title="Language of the analysis text. The interface stays English."
        >
          {(["en", "pl"] as Lang[]).map((option) => (
            <button
              key={option}
              type="button"
              className={lang === option ? "active" : ""}
              aria-pressed={lang === option}
              onClick={() => setLang(option)}
            >
              {option.toUpperCase()}
            </button>
          ))}
        </div>
        <button className="icon-btn" title="History">
          <Icon name="history" size={17} />
        </button>
        <button className="icon-btn" title="Notifications">
          <Icon name="bell" size={17} />
        </button>
      </div>
    </header>
  );
}
